import { FormControl, Grid, InputLabel, TextField, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import React from 'react';
import { useTranslation } from '../../../../../commons/useTranslasion';

interface Props {
  novoUsuario: boolean;
}

const PPCStepper5: React.FC<Props> = (props: Props) => {
  const { translate } = useTranslation();
  const { novoUsuario } = props;
  const methods = useFormContext();

  return (
    <>
      <Grid container xs={12} md={12} sm={12} sx={{
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
      }}>
        <Grid xs={12} md={12} sm={12}>
          <Typography sx={{ padding: "10px 0px" }} variant="h5" component="h2">
            {translate("ReflexaoDeCarreriaTitulo")}
          </Typography>
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal", fontWeight: "700"
          }}>
            {translate("ReflexaoDeCarreriaP1")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP1'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                disabled
                multiline
                maxRows={4}
                inputProps={{style: {fontWeight: "700"}}}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal", fontWeight: "700"
          }}>
            {translate("ReflexaoDeCarreriaP2")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP2'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}

                variant="standard"
                disabled
                multiline
                maxRows={4}
                inputProps={{style: {fontWeight: "700"}}}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal", fontWeight: "700"
          }}>
            {translate("ReflexaoDeCarreriaP3")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP3'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                disabled
                multiline
                maxRows={4}
                inputProps={{style: {fontWeight: "700"}}}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal", fontWeight: "700"
          }}>
            {translate("ReflexaoDeCarreriaP4")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP4'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                disabled
                multiline
                maxRows={4}
                inputProps={{style: {fontWeight: "700"}}}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal", fontWeight: "700"
          }}>
            {translate("ReflexaoDeCarreriaP5")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP5'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                disabled
                multiline
                maxRows={4}
                inputProps={{style: {fontWeight: "700"}}}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal", fontWeight: "700"
          }}>
            {translate("ReflexaoDeCarreriaP6")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP6'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                disabled
                multiline
                maxRows={4}
                inputProps={{style: {fontWeight: "700"}}}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal", fontWeight: "700"
          }}>
            {translate("ReflexaoDeCarreriaP7")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP7'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                disabled
                multiline
                maxRows={4}
                inputProps={{style: {fontWeight: "700"}}}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal", fontWeight: "700"
          }}>
            {translate("ReflexaoDeCarreriaP8")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP8'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                disabled
                multiline
                maxRows={4}
                inputProps={{style: {fontWeight: "700"}}}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal", fontWeight: "700"
          }}>
            {translate("ReflexaoDeCarreriaP9")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='reflexaoDeCarreiraP9'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                disabled
                multiline
                maxRows={4}
                inputProps={{style: {fontWeight: "700"}}}
              />
            )}
          />
        </Grid>
      </Grid>

    </>
  );
};

export default PPCStepper5;
